<template>
    <div class="ui-tabs">
        <button
        v-for="item in itemList"
        class="item"
        :class="[
            { on: on === item.value },
            { hasIcon: item.icon },
            { onlyIcon: hideLabel },
            {disabled: item.disabled}
        ]"
        :key="item.value"
        @click="$emit('select', item.value)"
        >
            <i v-if="item.icon" class="icon default" :class="item.icon"/>
            <i v-if="item.iconHover" class="icon hover" :class="item.iconHover"/>
            <i v-if="item.iconActive" class="icon active" :class="item.iconActive"/>
            <p v-if="!hideLabel" class="text" >{{ item.label || item.value }}</p>
        </button>
    </div>
</template>
<script>
export default {
  name: 'UiTabs',
  components: {},
  props: {
    itemList: {
      type: Array,
      required: true
    },
    on: {
      type: String,
      required: true
    },
    useIcon: {
      type: Boolean,
      default: false
    },
    hideLabel: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.ui-tabs {
    display: flex;
    border: solid 1px #e0e0e0;
    border-radius: 20px;

    button {
        position: relative;
        padding: 12px 17px;
        border-radius: 20px;
        font-size: 13px;
        line-height: 1;
        color: #888888;

        .icon {
            position: absolute;
            top: 9px;
            left: 17px;
            width: 20px;
            height: 20px;
            background-size: cover;
            background-position: center center;
            vertical-align: middle;
            opacity: 1;
            transition: opacity 0.2s ease;

            &.hover {
                opacity: 0;
            }

            &.active {
                opacity: 0;
            }
        }

        &.on {
            box-shadow: 0 12px 10px -4px rgba(0, 0, 0, 0.2);
            pointer-events: none;

            .icon {
                &.default {
                    opacity: 0;
                }
                &.hover {
                    opacity: 0;
                }
                &.active {
                    opacity: 1;
                }
            }

            .text {
                position: relative;
                color: #fff;
                z-index: 1;
            }
            &:before {
                content: '';
                position: absolute;
                top: -1px;
                left: -1px;
                width: calc(100% + 2px);
                height: calc(100% + 2px);
                background-color: #ec0147;
                border-radius: 20px;
            }
        }

        &.hasIcon {
            padding: 12px 15px;
            .text {
                min-width: 42px;
                text-align: center;
                margin-left: 25px;
            }
        }

        &.onlyIcon {
            min-width: 85px;
            .icon {
                left: 50%;
                transform: translateX(-50%);
            }
        }

        &:hover {
            .icon {
                &.default {
                    opacity: 0;
                }
                &.hover {
                    opacity: 1;
                }
            }

            &:not(.on) .text {
                color: #444;
            }
            &:disabled .text {
                color: #ccc;
            }
        }
        &:not(:first-child) {
            margin-left: -8px;
        }
        &.disabled {
            pointer-events: none;
            color: #C7C7C7;
        }
    }
}
</style>
